import { useState } from 'react';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Dashboard from './components/Dashboard';
import LessonsPage from './components/LessonsPage';
import PracticeQuiz from './components/PracticeQuiz';
import ApiKeyModal from './components/ApiKeyModal';
import { useApiKey } from './hooks/useApiKey';

export default function App() {
  const [page, setPage] = useState('dashboard');
  const [lessonNav, setLessonNav] = useState({ topicKey: null, subtopic: null, ts: 0 });
  const { apiKey, showModal, setShowModal, save } = useApiKey();

  const navigateTo = (p) => setPage(p);

  const loadLesson = (topicKey, subtopic) => {
    setPage('lessons');
    setLessonNav({ topicKey, subtopic, ts: Date.now() });
  };

  return (
    <div className="app-layout">
      {showModal && (
        <ApiKeyModal onSave={save} onDismiss={() => setShowModal(false)} />
      )}

      <Sidebar
        activePage={page}
        onNavigate={navigateTo}
        onSelectTopic={(key) => loadLesson(key, null)}
      />

      <div className="main-area">
        <Topbar
          activePage={page}
          apiKey={apiKey}
          onKeyClick={() => setShowModal(true)}
          onStartLesson={() => navigateTo('lessons')}
        />

        <div className="content">
          {page === 'dashboard' && (
            <Dashboard onNavigate={navigateTo} onLoadLesson={loadLesson} />
          )}
          {page === 'lessons' && (
            <LessonsPage
              key={lessonNav.ts}
              initialTopicKey={lessonNav.topicKey}
              initialSubtopic={lessonNav.subtopic}
            />
          )}
          {page === 'quiz' && <PracticeQuiz />}
        </div>
      </div>
    </div>
  );
}
